import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  IconButton,
  Collapse,
  Box,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

const ExpandableValueTable = ({ valueStocks }) => {
  const [openRows, setOpenRows] = useState(() => valueStocks.map(() => false));

  const toggleRow = (index) => {
    setOpenRows((prev) => {
      const newState = [...prev];
      newState[index] = !newState[index];
      return newState;
    });
  };

  return (
    <TableContainer component={Paper} sx={{ mt: 3, borderRadius: 2, boxShadow: 3 }}>
      <Table size="small">
        <TableHead sx={{ backgroundColor: "#2d4890" }}>
          <TableRow>
            <TableCell />
            {[
              "Stock",
              "ROE",
              "ROCE",
              "Index Satisfied",
              "Beta",
              "Shm",
              "Rank",
              "Volume",
              "Company",
              "Sector",
              "Industry",
            ].map((header) => (
              <TableCell key={header} sx={{ color: "white", fontWeight: 600, whiteSpace: "nowrap" }}>
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {valueStocks.map((stock, index) => {
            const roeYears = [
              stock["ROE_Mar 20"],
              stock["ROE_Mar 21"],
              stock["ROE_Mar 22"],
              stock["ROE_Mar 23"],
              stock["ROE_Mar 24"],
            ];
            const roceYears = [
              stock["ROCE_Mar 20"],
              stock["ROCE_Mar 21"],
              stock["ROCE_Mar 22"],
              stock["ROCE_Mar 23"],
              stock["ROCE_Mar 24"],
            ];

            return (
              <React.Fragment key={stock.Ticker + index}>
                <TableRow
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                    "&:hover": { backgroundColor: "#f0f4ff" },
                  }}
                >
                  <TableCell>
                    <IconButton size="small" onClick={() => toggleRow(index)}>
                      {openRows[index] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                  </TableCell>
                  <TableCell>{stock.Ticker}</TableCell>
                  <TableCell>{roeYears[roeYears.length - 1]}</TableCell>
                  <TableCell>{roceYears[roceYears.length - 1]}</TableCell>
                  <TableCell>{stock["Indexes Satisfied"]}</TableCell>
                  <TableCell>{stock["Beta values"]}</TableCell>
                  <TableCell>{stock["ShM values"]}</TableCell>
                  <TableCell>{stock.Avg_Price_Rank?.toFixed(2)}</TableCell>
                  <TableCell>{stock["5 Day Avg Volume (Cr)"]?.toFixed(2)}</TableCell>
                  <TableCell sx={{ maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {stock["Company Name"]}
                  </TableCell>
                  <TableCell>{stock.Sector}</TableCell>
                  <TableCell>{stock.Industry}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell colSpan={12} sx={{ paddingBottom: 0, paddingTop: 0, backgroundColor: "#f4f7ff" }}>
                    <Collapse in={openRows[index]} timeout="auto" unmountOnExit>
                      <Box sx={{ margin: 1 }}>
                        <strong>Full ROE:</strong> {JSON.stringify(roeYears)} <br />
                        <strong>Full ROCE:</strong> {JSON.stringify(roceYears)}<br />
                         <strong>Company Name:</strong> {stock["Company Name"]}
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ExpandableValueTable;
